import { useContext, useEffect } from 'react';
import { CountdownContext } from '../context';
import {
  ClockContainerWrap,
  DotWrap,
  FlipCardWrap,
  SegmentWrap,
} from './styles/flipClock.style';

const FlipClock = ({
  $dotColor = '#fff',
  $clockColor = '#fff',
  timeOver = false,
  style,
}) => {
  const countdown = useContext(CountdownContext);

  function flip(flipCard, newNumber) {
    const topHalf = flipCard.querySelector('.top > span');
    const startNumber = parseInt(topHalf.textContent, 10);
    if (newNumber === startNumber) return;

    const bottomHalf = flipCard.querySelector('.bottom > span');

    const topFlip = document.createElement('div');
    const topFlipText = document.createElement('span');
    topFlip.classList.add('top-flip');
    topFlip.appendChild(topFlipText);

    const bottomFlip = document.createElement('div');
    const bottomFlipText = document.createElement('span');
    bottomFlip.classList.add('bottom-flip');
    bottomFlip.appendChild(bottomFlipText);

    topHalf.textContent = startNumber;
    bottomHalf.textContent = startNumber;
    topFlipText.textContent = startNumber;
    bottomFlipText.textContent = newNumber;

    topFlip.addEventListener('animationstart', () => {
      topHalf.textContent = newNumber;
    });
    topFlip.addEventListener('animationend', () => {
      topFlip.remove();
    });
    bottomFlip.addEventListener('animationend', () => {
      bottomHalf.textContent = newNumber;
      bottomFlip.remove();
    });
    flipCard.append(topFlip, bottomFlip);
  }

  function flipAllCards(time) {
    const seconds = time % 60;
    const minutes = Math.floor(time / 60) % 60;
    const hours = Math.floor(time / 3600);

    flip(document.querySelector('[data-hours-tens]'), Math.floor(hours / 10));
    flip(document.querySelector('[data-hours-ones]'), hours % 10);
    flip(
      document.querySelector('[data-minutes-tens]'),
      Math.floor(minutes / 10),
    );
    flip(document.querySelector('[data-minutes-ones]'), minutes % 10);
    flip(
      document.querySelector('[data-seconds-tens]'),
      Math.floor(seconds / 10),
    );
    flip(document.querySelector('[data-seconds-ones]'), seconds % 10);
  }

  useEffect(() => {
    if (!timeOver) {
      flipAllCards(Math.ceil(countdown));
    }
  }, [countdown, timeOver]);

  return (
    <ClockContainerWrap style={style}>
      <SegmentWrap className="hours">
        <FlipCardWrap data-hours-tens $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
        <FlipCardWrap data-hours-ones $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
      </SegmentWrap>
      <DotWrap $dotColor={$dotColor}>
        <span className="top" />
        <span className="bottom" />
      </DotWrap>
      <SegmentWrap className="minutes">
        <FlipCardWrap data-minutes-tens $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
        <FlipCardWrap data-minutes-ones $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
      </SegmentWrap>
      <DotWrap $dotColor={$dotColor}>
        <span className="top" />
        <span className="bottom" />
      </DotWrap>
      <SegmentWrap className="seconds">
        <FlipCardWrap data-seconds-tens $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
        <FlipCardWrap data-seconds-ones $clockColor={$clockColor}>
          <div className="top">
            <span>0</span>
          </div>
          <div className="bottom">
            <span>0</span>
          </div>
        </FlipCardWrap>
      </SegmentWrap>
    </ClockContainerWrap>
  );
};

export default FlipClock;
